var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHomeIcon = function SvgHomeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M6.902 11.98h2.133V18H16V6.02L7.906 0 0 6.02V18h6.902zm-2.008 4.013v-6.02h6.15v6.02h2.948V7.029L7.92 2.512 2.008 7.015v8.978z",
    clipRule: "evenodd"
  })));
};
export default SvgHomeIcon;